import React from "react";
import { Button, Flex, GridItem, Spinner } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Form, Grid, ImageUploader, TextInput, Wrapper } from "components";
import { useParams } from "duck";
import { useGetOrganizationAdminUserQuery } from "requests";
import { FormValues, getValidation, useUpdateOrganizationAdmin } from "./duck";

const Admin: React.FC = () => {
  const { id } = useParams();
  const { data, loading } = useGetOrganizationAdminUserQuery({
    fetchPolicy: "no-cache",
    variables: {
      organization: +id
    }
  });
  const admin = data?.organizationAdminUser;
  const update = useUpdateOrganizationAdmin(admin?._id);
  const navigate = useNavigate();

  if (!admin || loading) {
    return (
      <Flex justify="center">
        <Spinner />
      </Flex>
    );
  }

  return (
    <Wrapper>
      <Form<FormValues> {...getValidation(admin)} onSubmit={update}>
        <Grid templateColumns="repeat(2, 1fr)">
          <GridItem>
            <TextInput
              name="firstName"
              label="First Name"
              placeholder="First Name"
            />
          </GridItem>
          <GridItem>
            <TextInput
              name="lastName"
              label="Last Name"
              placeholder="Last Name"
            />
          </GridItem>
          <GridItem>
            <TextInput name="email" label="Email" placeholder="Email" />
          </GridItem>
          <GridItem colStart={1}>
            <ImageUploader name="image" label="Picture" />
          </GridItem>
        </Grid>
        <Form.Controls mt={6} submitText="Save">
          <Button
            variant="outline"
            colorScheme="gray"
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
        </Form.Controls>
      </Form>
    </Wrapper>
  );
};

export default Admin;
